import Covenant from './Covenant';

export default Covenant;


// WEBPACK FOOTER //
// ./src/pages/Covenant/components/index.js